// src/components/ShiftGrid.tsx
import React, { useEffect, useState } from 'react';
import { Shift, UserWithShift } from './types';
import { fetchShifts } from './api';
import moment from 'moment';
import styled from 'styled-components';
import {
	StyledPaper,
	StyledTable,
	StyledTableCell,
	StyledTableRow,
	StyledCard,
	StyledCardContent
  } from './StyledTable';
import { TableBody, TableHead } from '@material-ui/core';

interface GroupedUser {
	id: string;
	displayName: string;
	email: string;
	firstName: string;
	lastName: string;
	shifts: Shift[];
}

const ShiftGrid: React.FC = () => {
	const [groupedUsers, setGroupedUsers] = useState<GroupedUser[]>([]);
	const daysOfWeek: Array<{ day: string, renderDay: string }> = Array.from({ length: 3 }, (_, i) => {
		const render = {
			day: moment().add(i, 'days').format('YYYY-MM-DD'),
			renderDay: ''
		}

		if (i === 0) {
			render.renderDay = 'TODAY';
		} else if (i === 1) {
			render.renderDay = 'TOMORROW';
		} else {
			render.renderDay = moment().add(i, 'days').format('MM/DD');
		}

		return render;
	});

	useEffect(() => {
		const fetchData = async () => {
			const data = await fetchShifts();
			const grouped = data.reduce((acc: { [key: string]: GroupedUser }, curr) => {
				if (!acc[curr.userId]) {
					acc[curr.userId] = {
						id: curr.id,
						displayName: curr.displayName,
						email: curr.email,
						firstName: curr.firstName,
						lastName: curr.lastName,
						shifts: [],
					};
				}
				acc[curr.userId].shifts.push(curr.sharedShift);
				return acc;
			}, {});
			// @ts-ignore
			setGroupedUsers(Object.values(grouped).sort((a, b) => a.displayName.localeCompare(b.displayName)));
		};

		fetchData();
	}, []);

	const splitArrayIntoChunks = (array: GroupedUser[], chunkSize: number) => {
		const chunks = [];
		for (let i = 0; i < array.length; i += chunkSize) {
			chunks.push(array.slice(i, i + chunkSize));
		}
		return chunks;
	};

	const chunkedUsers = splitArrayIntoChunks(groupedUsers, Math.ceil(groupedUsers.length / 3));
	
	return (
		<Container>
			{chunkedUsers.map((usersChunk, index) => (
				<StyledPaper key={index} style={{ marginBottom: '20px' }}>
					<StyledTable>
						<TableHead>
							<StyledTableRow>
								<StyledTableCell>USER</StyledTableCell>
								{daysOfWeek.map(item => (
									<StyledTableCell key={item.day}>{item.renderDay}</StyledTableCell>
								))}
							</StyledTableRow>
						</TableHead>
						<TableBody>
							{usersChunk.map(user => (
								<StyledTableRow key={user.id}>
									<StyledTableCell>{user.displayName}</StyledTableCell>
									{daysOfWeek.map(item => (
										<StyledTableCell key={item.day}>
											{user.shifts
												.filter(shift => moment(shift.startDateTime).isSame(item.day, 'day'))
												.map(shift => (
													<StyledCard key={shift.startDateTime} variant="outlined">
														<StyledCardContent>
															{moment(shift.startDateTime).format('HH:mm')} - {moment(shift.endDateTime).format('HH:mm')}
															{/* <br />
															{shift.notes} */}
														</StyledCardContent>
													</StyledCard>
												))}
										</StyledTableCell>
									))}
								</StyledTableRow>
							))}
						</TableBody>
					</StyledTable>
				</StyledPaper>
			))}
		</Container>
	);
};

export default ShiftGrid;

const Container = styled.div`
	display: flex;
	gap: 10px;
`;
